import React from 'react'
import styled from 'styled-components/macro'

import { ColorsMap } from '@/utils/Theme'

import { BannerChanger } from '../Slider'
import Sale2026 from '../Hummel/Sale2026'

interface BrandDescriptionProps {
  content: string
  banner: string[]
  brand?: string | string[]
}

export const BrandDescription: React.FC<BrandDescriptionProps> = ({ content, banner, brand }) => {
  return (
    <Wrapper>
      {banner.length > 0 && (
        <>
          {banner.length > 1 ? (
            <BannerChanger sliderContent={banner.map((item) => ({ image: item }))} />
          ) : (
            <BannerWrapper>
              <img src={banner[0]} alt="" />
            </BannerWrapper>
          )}
        </>
      )}

      {brand === 'hummel' && <Sale2026 />}

      {content && (
        <Description>
          <Uppertext dangerouslySetInnerHTML={{ __html: content }} />
        </Description>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const BannerWrapper = styled.div`
  width: 100%;
  height: fit-content;

  > img {
    width: 100%;
  }
`

const Description = styled.div`
  margin: 3.5rem 13%;
  color: ${ColorsMap.black};
`

const Uppertext = styled.div`
  & > p {
    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
`

